// store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import { ipReducer } from "./slices/IPSlice";
import {
  dashboardEarningReducer,
  dashboardItemSoldReducer,
  dashboardNewOrderReducer,
  dashProductsReducer,
  dashTopSellerReducer,
  dashboardShopCatSliceReducer,
  dashboardProductReviewsReducer,
  dashboardRatingSliceReducer,
  dashboardRecentOrdersReducer,
  dashRevenuReducer,
  dashPastTrendsReducer,
  orderStatisticsReducer,
} from "./slices/dashboardSlice";
import {
  allProductDomainsReducer,
  parentByDomainReducer,
  sellerProductCategoriesReducer,
} from "./slices/sellerProductCategoriesSlice";
import { ReviewReducer } from "./slices/reviewSlice";
import {
  reportsAnalyticsOrderReducer,
  reportsAnalyticsProductsReducer,
  reportsAnalyticsStockInfoReducer,
} from "./slices/reportsAnalyticsSlice";
import {
  addInventoryReducer,
  cancellationPolicyReducer,
  inventoryDetailsReducer,
  returnPolicyReducer,
  saveCancellationPolicyReducer,
  suppliersReducer,
  updateCancellationPolicyReducer,
  updateInventoryReducer,
  updateReturnPolicyReducer,
  vendorStoresReducer,
} from "./slices/vendorStoreSlice";
import {
  deleteStockReducer,
  detailsSaleListReducer,
  getDosageReducer,
  inventoryListReducer,
  removeSaleReducer,
  targetCropConcernReducer,
  updateSaleReducer,
  updateStockReducer,
  updateStockStatusReducer,
} from "./slices/InventorySlice";
import { allBrandsReducer, brandsReducer } from "./slices/brandSlice";
import {
  approvalRequestReducer,
  productDetailsReducer,
  productListingReducer,
  saveProductReducer,
  saveStockReducer,
  variantWithoutInvntoryReducer,
  vendorProductDetailsReducer,
} from "./slices/productSlice";
import { storeReducer } from "./slices/storeSlice";
import {
  childLocationReducer,
  parentLocationReducer,
} from "./slices/locationSlice";
import {
  acceptReturnReducer,
  changeReturnStatusReducer,
  returnBarReducer,
  returnDetailReducer,
  returnReducer,
  returnShipmentReducer,
} from "./slices/returnSlice";
import {
  approveOrderReducer,
  changeStatusInStoreReducer,
  generatedInvoicesByRefsReducer,
  generateManifestReducer,
  getSellerListingReducer,
  getStoresListingReducer,
  orderBarReducer,
  orderChangeStatusReducer,
  orderInStoreReducer,
  orderOverviewReducer,
  orderPaymentReducer,
  orderReducer,
  orderRemarkHistoryReducer,
  orderRevenueReducer,
  orderShipmentHistoryReducer,
  orderShippingReducer,
  orderTransactionReducer,
  pendingAmountReduucer,
  prinntInvoiceReducer,
  printLabelReducer,
  saveOrderRemarksReducer,
  settlementReducer,
  uploadBloodSampleReportReducer,
  wayuvegaReducer,
} from "./slices/orderSlice";
import { getLanguagesReducer } from "./slices/getLanguagesSlice";
import {
  getVendorByIdReducer,
  updatePortalPasswordReducer,
  updatePortalUserReducer,
} from "./slices/myProfileSlice";

// Combine reducers (in case you add more later)
const appReducer = combineReducers({
  auth: authReducer,
  ip: ipReducer,
  vendorById: getVendorByIdReducer,
  updatePortalUser: updatePortalUserReducer,
  updatePortalPassword: updatePortalPasswordReducer,
  vendorStoresOption: vendorStoresReducer,
  sellerDomainCategory: sellerProductCategoriesReducer,
  dashboardItemSold: dashboardItemSoldReducer,
  dashNewOrder: dashboardNewOrderReducer,
  dashEarning: dashboardEarningReducer,
  dashTotalProduct: dashProductsReducer,
  dashTopSeller: dashTopSellerReducer,
  dashPastTrends: dashPastTrendsReducer,
  orderStatistics: orderStatisticsReducer,
  dashShopCat: dashboardShopCatSliceReducer,
  dashRevenu: dashRevenuReducer,
  dashboardProductReviews: dashboardProductReviewsReducer,
  dashRecentOrder: dashboardRecentOrdersReducer,
  dashboardRating: dashboardRatingSliceReducer,
  reportsAnalyticsOrder: reportsAnalyticsOrderReducer,
  reportAnalyticsStockInfo: reportsAnalyticsStockInfoReducer,
  reportsAnalyticsProducts: reportsAnalyticsProductsReducer,
  reviews: ReviewReducer,
  brandsList: brandsReducer,
  inventoryList: inventoryListReducer,
  updateStockStatus: updateStockStatusReducer,
  deleteStock: deleteStockReducer,
  updateSale: updateSaleReducer,
  detailsSaleList: detailsSaleListReducer,
  productListing: productListingReducer,
  productDetails: productDetailsReducer,
  variantWithoutInventory: variantWithoutInvntoryReducer,
  saveStockData: saveStockReducer,
  removeSale: removeSaleReducer,
  getDosage: getDosageReducer,
  targetCropConcern: targetCropConcernReducer,
  updateStock: updateStockReducer,
  allBrands: allBrandsReducer,
  allProductDomains: allProductDomainsReducer,
  parentByDomain: parentByDomainReducer,
  saveProductData: saveProductReducer,
  approvalRequests: approvalRequestReducer,
  vendorProductDetails: vendorProductDetailsReducer,
  storeData: storeReducer,
  inventoryDetails: inventoryDetailsReducer,
  addInventory: addInventoryReducer,
  updateInventory: updateInventoryReducer,
  returnPolicy: returnPolicyReducer,
  cancellationPolicy: cancellationPolicyReducer,
  suppliers: suppliersReducer,
  updateReturnPolicy: updateReturnPolicyReducer,
  updateCancellationPolicy: updateCancellationPolicyReducer,
  saveCancellationPolicy: saveCancellationPolicyReducer,
  parentLocation: parentLocationReducer,
  childLocations: childLocationReducer,
  returnListing: returnReducer,
  returnDetail: returnDetailReducer,
  returnBar: returnBarReducer,
  returnShipment: returnShipmentReducer,
  changeReturnStatus: changeReturnStatusReducer,
  acceptReturn: acceptReturnReducer,
  orderListing: orderReducer,
  orderOverview: orderOverviewReducer,
  orderTransaction: orderTransactionReducer,
  orderPayment: orderPaymentReducer,
  saveOrderRemark: saveOrderRemarksReducer,
  orderRemarkHistory: orderRemarkHistoryReducer,
  orderShipping: orderShippingReducer,
  orderInStore: orderInStoreReducer,
  changeStatusInStore: changeStatusInStoreReducer,
  orderBar: orderBarReducer,
  changeStatusOrder: orderChangeStatusReducer,
  shipmentHistory: orderShipmentHistoryReducer,
  printInvoice: prinntInvoiceReducer,
  printLabel: printLabelReducer,
  approveOrder: approveOrderReducer,
  pendingAmount: pendingAmountReduucer,
  getLanguages: getLanguagesReducer,
  wayuvega: wayuvegaReducer,
  orderRevenue: orderRevenueReducer,
  settlements: settlementReducer,
  getSellerListing: getSellerListingReducer,
  getStoresListing: getStoresListingReducer,
  generatemanifest: generateManifestReducer,
  uploadBloodSampleReport: uploadBloodSampleReportReducer,
  generatedInvoicesByRefs: generatedInvoicesByRefsReducer,
});

// ================== RESET WRAPPER ==================

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined; // 🔥 resets entire redux state
  }
  return appReducer(state, action);
};

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "sellerDomainCategory",
    "allProductDomains",
    "allBrands",
    "storeData",
  ],
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

// Persistor
export const persistor = persistStore(store);
